import Order from "modules/Admin/orders/Order"

function OrderPage() {
  return (
    <div data-testid="adminOrderPage">
      <Order />
    </div>
  )
}

export default OrderPage